import React from 'react';
import { 
  PrinterWMO,
  PackageWMO,
  TruckWMO
} from "@usap/uicomponents";
import { Heading, Section, TextWrapper, Label, ImageBox } from "../style/PrepaidShippingLabelWMO.css"

export default function PrepaidShippingLabelWMO() {
  return (
    <>
      <Heading>
        Here&apos;s how to get your item(s) back to us:
      </Heading>
      <Section>
        <ImageBox>
          <PrinterWMO />
        </ImageBox>
        <TextWrapper>
          <Label>1.</Label>
          <Label>
            Print your Shipping Label. No printer? No worries!
            You can pull up this Shipping Label
            from your return confirmation email or return history in
            your account and print at your convenience.
          </Label>
        </TextWrapper>
      </Section>
      <Section>
        <ImageBox>
          <PackageWMO />
        </ImageBox>
        <TextWrapper>
          <Label>2.</Label>
          <Label>
            Pack your items with the return
            form and attach the Shipping Label to your package.
            Make sure any old barcodes or markings on the package are covered.
          </Label>
        </TextWrapper>
      </Section>
      <Section>
        <ImageBox>
          <TruckWMO />
        </ImageBox>
        <TextWrapper>
          <Label>3.</Label>
          <Label>
            Ship your return at any FedEx location near you.
            We&apos;ll email you when your package arrives and
            your return is being processed.
          </Label>
        </TextWrapper>
      </Section>
    </>
  )
}
